// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mpfdecEntity from './entities/mpfdec.json';
import mpfdecMenu from '../pages/mpfdec/menu.json';
import mpfdecFullForm from '../pages/mpfdec/forms/full.json';
import mpfdecContextForm from '../pages/mpfdec/forms/context.json';
import mpfdecMiniForm from '../pages/mpfdec/forms/mini.json';
import mpfdecLookupForm from '../pages/mpfdec/forms/lookup.json';
import mpfdecTableView from '../pages/mpfdec/views/table.json';
import mpfdecStagesView from '../pages/mpfdec/views/stages.json';
import mpfdecCardsView from '../pages/mpfdec/views/cards.json';
import mpfdecInlineView from '../pages/mpfdec/views/inline.json';
import mpfdecBacklogView from '../pages/mpfdec/views/backlog.json';
import mpfdecSplitView from '../pages/mpfdec/views/split.json';
import mpfdecCalendarView from '../pages/mpfdec/views/calendar.json';
import mpfdecDashboardView from '../pages/mpfdec/views/dashboard.json';

/** Тип запису «Декларація» зі сторінками пакета: меню, форми та подання з pages/mpfdec/. */
export const mpfdecDefinition: IRecordTypeDefinition = {
  ...mpfdecEntity,
  views: assembleViewSet({
      table: mpfdecTableView,
      stages: mpfdecStagesView,
      cards: mpfdecCardsView,
      inline: mpfdecInlineView,
      backlog: mpfdecBacklogView,
      split: mpfdecSplitView,
      calendar: mpfdecCalendarView,
      dashboard: mpfdecDashboardView,
  }),
  form: mpfdecFullForm,
  forms: { full: mpfdecFullForm, context: mpfdecContextForm, mini: mpfdecMiniForm, lookup: mpfdecLookupForm },
  menu: mpfdecMenu,
} as IRecordTypeDefinition;
